
// OrdersPage.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCommentDots } from 'react-icons/fa';
import { MdFastfood } from 'react-icons/md';

const statusSummary = [
  { label: 'All', count: 6, color: 'bg-primary', text: 'text-white' },
  { label: 'New', count: 2, color: 'border-orange-500', text: 'text-orange-500' },
  { label: 'Process', count: 2, color: 'border-yellow-500', text: 'text-yellow-500' },
  { label: 'Done', count: 2, color: 'bg-green-600', text: 'text-white' }
];

const orders = [
  { id: '#000000', type: 'Table - 1', time: '5 mins ago', item: 'Item-1', status: 'Done', border: 'border-green-500' },
  { id: '#000000', type: 'Online Order', time: '5 mins ago', item: 'Item-1', status: 'Process', border: 'border-orange-500' },
  { id: '#000000', type: 'Online Order', time: '25 mins ago', item: 'Item-1', status: 'Done', border: 'border-green-500', completed: true, items: ['Ice Cream', 'Ice Cream', 'Ice Cream'] }
];

const OrdersPage = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen  p-4 md:p-8">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <FaArrowLeft className="text-xl cursor-pointer" onClick={() => navigate(-1)} />
          <h1 className="text-xl md:text-2xl font-semibold capitalize">{type.replace('-', ' ')}</h1>
        </div>
        {/* <FaCommentDots className="text-xl text-primary" /> */}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {statusSummary.map((status, idx) => (
          <div
            key={idx}
            className={`rounded-xl px-4 py-3 text-center font-semibold text-sm ${status.color.includes('bg') ? status.color : 'border ' + status.color}` +
              ` ${status.text}`}
          >
            <div>{status.count.toString().padStart(2, '0')}</div>
            <div>{status.label}</div>
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-4">
        {orders.map((order, idx) => (
          <div
            key={idx}
            className={`rounded-xl border ${order.border} p-4 bg-white`}
          >
            <div className="flex justify-between items-center mb-2">
              <div className="text-lg font-bold">{order.id}</div>
              <div className="text-sm text-gray-500">{order.time}</div>
            </div>

            <div className="flex justify-between items-center mb-2">
              <span className="text-xs border border-black px-2 py-1 rounded-full">
                {order.type}
              </span>
              <span
                className={`text-xs px-2 py-1 rounded-full ${
                  order.status === 'Done'
                    ? 'bg-green-600 text-white'
                    : 'bg-orange-500 text-white'
                }`}
              >
                {order.item}
              </span>
            </div>

            {order.completed && (
              <div className="mt-4">
                {order.items.map((item, index) => (
                  <div key={index} className="flex justify-between py-1">
                    <span>{item}</span>
                    <span>x1</span>
                  </div>
                ))}
                <div className="flex items-center gap-2 text-green-600 mt-2">
                  <MdFastfood className="text-lg" />
                  <span className="text-sm font-medium">Order Completed</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrdersPage;
